import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StoreHighlight } from '../../detail/store-detail-page/store-critical-insights-panel/store-highlights-panel/store-highlight';

@Injectable({
  providedIn: 'root'
})
export class HighlightsDataService {
  private highlightsSubject = new BehaviorSubject<StoreHighlight[]>([]);
  public highlights$ = this.highlightsSubject.asObservable();

  updateHighlights(highlights: StoreHighlight[]): void {
    this.highlightsSubject.next(highlights);
  }

  getHighlights(): StoreHighlight[] {
    return this.highlightsSubject.value;
  }
}